module.exports = __webpack_public_path__ + "img/mvl-calc-yellow.4a5bf738.jpg";